import { render, staticRenderFns } from "./my-issue-topic.vue?vue&type=template&id=50c6573c&scoped=true&"
import script from "./my-issue-topic.vue?vue&type=script&lang=js&"
export * from "./my-issue-topic.vue?vue&type=script&lang=js&"
import style0 from "./my-issue-topic.vue?vue&type=style&index=0&id=50c6573c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c6573c",
  null
  
)

export default component.exports